import TermCreateForm from './term-create-form'

export default TermCreateForm;